<template>
  <b-container fluid>
    <h3>{{ $t('Kontaktformular') }}</h3>
    <p v-html="$t('HabenSieFragen')"></p>
    <b-form>
      <b-form-textarea
        id="anliegen"
        v-model="anliegen"
        :placeholder="$t('BitteAnliegenBeschreiben')"
        :rows="6"
      ></b-form-textarea>
      <b-button class="mt-3" variant="primary" @click.stop="send">{{$t('Senden')}}</b-button>
    </b-form>
    <p v-html="$t('KontaktTSM')"></p>
  </b-container>
</template>

<script>
import { bus, axios, apiURL, i18n } from "../main";

export default {
  name: "kontakt",
  data() {
    return {
      anliegen: ""
    };
  },

  methods: {
    send() {
      if (this.anliegen.length > 0) {
        let self=this;
        const formData = new FormData();
        formData.append("text", this.anliegen);
        axios.post(apiURL + "userManager.cfc?method=sendEmail", formData).then(function() {
          bus.$emit("success", i18n.t("DankMitteilung"))
          self.anliegen = ''
          })
        /* messages sind ausgeschalten .. 
        
          .catch(function(e) {bus.$emit("error","Error sending email ... " + JSON.stringify(e.message))});
        */
      } else bus.$emit("message", this.$t("BitteAnliegenBeschreiben"));
    }
  },
  created() {},
  updated() {},
  mounted() {},
  components: {}
};
</script>